<div class="p-grid">
    <div class="p-col p-field">
        <label for="password">Contraseña</label>
        <input id="password" type="password" pInputText [(ngModel)]="changePswModal.password" placeholder="" autocomplete="new-password" />
    </div>
    <div class="p-col p-field">
        <label for="repeatPassword">Repita su contraseña</label>
        <input id="repeatPassword" type="password" pInputText [(ngModel)]="changePswModal.password2" placeholder="" autocomplete="new-password" />
    </div>
</div>
<div class="p-grid" *ngIf="changePswModal.password!=changePswModal.password2">
    <div class="p-col">
        <p-message severity="error" text="Las contraseñas deben coincidir" class="p-d-block"></p-message>
    </div>
</div>
<div class="p-grid">
    <div class="p-col">
        <button class="p-ml-2" style="float: right;" pButton type="button" label="Restablecer contraseña" (click)="changePassword()"></button>
        <button pButton class="p-button-link p-button-secondary" style="float: right;" (click)="cancel()" icon="pi pi-times" label="Cancelar"></button>
    </div>
</div>
